import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Story from '../../../endpoints/Story/Story';
import ContentGrid from '../../../grids/ContentGrid';
import Sidebar from '../../../components/Sidebar/Sidebar';
import fetcher from '../../../utils/fetcher';
import gql from '../../../endpoints/Story/StoryQuery';
import getStoryConfig from '../../../endpoints/Story/getStoryConfig';
import { parseEmbeddedAssets } from '../../../utils/utils';
import { globals } from '../../../config/globals';

import {
  fetchMemberDriveStatus,
  addMemberDriveElements,
} from '../../../utils/membershipUtils';

const StoryPage = ({ data, errorCode }) => {
  if (errorCode) return <ErrorPage statusCode={errorCode} />;

  useEffect(() => {
    fetchMemberDriveStatus().then((data) => {
      addMemberDriveElements(data);
    });
  }, []);

  let adUnitPathUrl = globals.adUnitPath;

  return (
    <ContentGrid sidebar={<Sidebar pageTopic={data.story.title} />}>
      <Story minimal={false} data={data} />
    </ContentGrid>
  );
};

StoryPage.getInitialProps = async ({ query: { slug, token }, res }) => {
  let data;
  let errorCode;
  let layout = 'default';

  await Promise.all([
    fetcher(gql, {
      contentAreaSlug: process.env.CONTENT_AREA_SLUG,
      slug: slug.join('/'),
      previewToken: token,
    }),
    getStoryConfig(),
  ])
    .then(([result, config]) => {
      data = { ...result, ...config };
      if (data?.story?.embeddedAssets) {
        parseEmbeddedAssets(data.story.embeddedAssets);
      }

      res.setHeader('Cache-Control', 'no-store, must-revalidate');
      if (!data.story) {
        res.statusCode = 404;
        errorCode = res.statusCode > 200 ? res.statusCode : false;
      } else {
        layout = data?.story?.primaryCollection?.templateName;
      }
    })
    .catch(() => {
      res.statusCode = 404;
      errorCode = res.statusCode > 200 ? res.statusCode : false;
    });

  return {
    data,
    errorCode,
    layout,
  };
};

StoryPage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  data: PropTypes.object,
};

export default StoryPage;
